import { z } from 'zod'

import { unfilledRecoveryPrebidBehaviours } from 'features/inventory/types/unfilledRecoveryPrebidBehaviour'
import { AdUnitForForm } from '../GeneralForm/hooks/useGetAdUnit'

export const schema = z.object({
  allowMultiformatEnabled: z.boolean(),
  customizePrebidBehaviour: z.boolean().default(false),
  id: z.string(),
  prebidBehaviourType: z.enum(unfilledRecoveryPrebidBehaviours).default('disabled'),
  unfilledRecoveryEnabled: z.boolean(),
})

export const schemaDefault = ({
  adUnitUnfilledRecovery: {
    allowMultiformatEnabled,
    customizePrebidBehaviour,
    prebidBehaviourType,
  },
  id,
  unfilledRecoveryEnabled,
}: AdUnitForForm): Schema => ({
  allowMultiformatEnabled,
  customizePrebidBehaviour,
  id,
  prebidBehaviourType,
  unfilledRecoveryEnabled,
})

export type Schema = z.infer<typeof schema>
